export interface DeviceEncash {
  UserId: string;
  DeviceId: string;
  Dts?: number;
  DeviceTimestamp: number;
  Banknotes: number;
  Coins: number;
  Id: string;
}

export interface UserEncash extends DeviceEncash {
  Address: string;
}

export type RawEncash = UserEncash | DeviceEncash;

export type Encash = (UserEncash | DeviceEncash) & { currency: Currency };

export interface EncashResponse {
  Items: RawEncash[];
  Count: number;
  Username: string;
  Currency: Currency;
  Next?: string;
}

export interface Currency {
  Code: string;
  Sign: string;
}

export enum ReportForm {
  file = 'file',
}

export interface EncashSumResponse {
  Banknotes: number;
  Coins: number;
  Currency: Currency;
}
